import { render, staticRenderFns } from "./Farm.vue?vue&type=template&id=bde5047a&scoped=true&lang=pug&"
import script from "./Farm.vue?vue&type=script&lang=ts&"
export * from "./Farm.vue?vue&type=script&lang=ts&"
import style0 from "./Farm.vue?vue&type=style&index=0&id=bde5047a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde5047a",
  null
  
)

export default component.exports